
let DrawerPoligon   = require('@/class/polygon');
let api             = require('@/api.js');
import tags         from '@/components/analytics/default_tags.js';
class Drawer {
	constructor(contentD, streamD, roiD,  shape, info_list, is_draw){
        // this.content    = null;
        this.roi        = null;
        // this.streaming  = null;

        // info
        this.stream     = {};

        this.context    = null;
        this.shape      = shape; 
        this.list       = [];
        this.drawers    = [];
        this.text       = '';
        this.color      = '';
        this.padding    = 5;

        this.camImage = new Image();
        this.camImage.src = (api && api.isdocker ? api.ext : "/") + 'img/tags/cam/camera_blue.png';//'img/tags/person/green2.png';


        // eventbus
        this.bus        = null;

        if (shape == 'polygon') {
            this.nodeRadius = 5;

        }else if(shape == 'rectangle'){
            // draw rect
            this.mousedown, 
            this.mouseup = false;
            this.resized = false;
            this.drawing = false;
            this.dragging = false;
            this.drawed = false;
            this.draged = false;
            this.aux_left = 0;
            this.aux_width = 0;
            this.aux_height = 0;
            this.resizing =  false;
            this.aux_top = 0;
            this.side = 0;
        }

        //propertys content
        this.current_width  = null;
        this.current_height = null;

        // contruct canvas and propertis
        this.contentD        = contentD;
        this.streamD         = streamD;        
        this.idx_point       = 0;
        this.content         = document.getElementById(contentD);
        this.streaming       = document.getElementById(streamD);
        this.listener_active = is_draw; // for active the listeners and draw
        this.contruct_draw(roiD,  shape, info_list);

        this.draw_setting              = {
          line_width : 3,
        };
        
        if (localStorage.getItem('streaming_paramaters')) {
            const info_get    =  JSON.parse(localStorage.getItem('streaming_paramaters'));
            if (info_get) {          
              this.draw_setting = info_get; 
            }
        }
        this.tags_images = this.render_tags();

	}
    /*
        deviceId : dev.deviceId,
        name     : dev.name,
        points   : [], / coords
        polygon  : [], / coords canv
        context  : null,
        shape    : 'polygon',
    */

    // render other shapes with one class

    contruct_draw(roiD,  shape, info_list){

        // this.roiD       = roiD;
        
        this.roi                        = document.getElementById(roiD); // + idx / canvas html
        // console.log(" COORDS /IDX , START draw " ,  roiD, this.roi);



        if (this.roi && this.roi.getContext("2d")) {
            // console.log("Context success");

            // set propertys width and heith content
            this.current_width  = this.roi.width  = this.streaming.getBoundingClientRect().width;
            this.current_height = this.roi.height = this.streaming.getBoundingClientRect().height;

            this.context        = this.roi.getContext("2d");

            if (this.context) {                
                this.set_color();
                if (this.listener_active) {
                    this.listener = false;
                    this.start_draw(this.roi);
                }
            }

            this.list.push({
                deviceId : info_list.deviceId,
                name     : info_list.name,
                roi      : this.roi,
                context  : this.context,
                drawer   : null,
                points   : [],
                polygon  : [],
                shape,
            });
            // console.log("context Created", this.context, this.list, info_list.name)
            return true;


        }else{
            console.warn("context incompatible or its null property html ", this.roi , roiD);
            return null;
        }
    }

    set_color_tags(color){
        this.tags_images = this.render_tags(color);

    }

    set_bus(EventBus){
        this.bus = EventBus;
    }

    set_list_shape(item){
        this.list = item;
    }

    setTextList(idx, text){
        if (idx >= 0 && this.list && this.list.length > 0 && this.list[idx]) {
            this.list[idx].name = text;
        }
    }
    get_list_shape(idx = false){

        // this.check_list();
        if (idx) {
            return this.list[idx];
        }
        return this.list;
    }
    getListShapeById(idx){
        if (idx>=0) {
            return this.list[idx];
        }
        return null
    }

    check_list(){
        if (this.list && this.list.length > 0) {
            let vm = this;
            vm.list.forEach((lis, idx_lis)=>{
                if (!lis.context) {
                    vm.list.splice(idx_lis, 1);
                }
            });
        }
    } // check list

    delete_list_shape(shape,item){
        // console.log("check delete_list_shape", item)
        if (item && this.list && this.list.length > 0) {
            let idx_del = this.list.findIndex( x => (x && x.deviceId == item.deviceId) );
                
                

            if (idx_del >= 0) {
                // console.log("CHECK REDUCE", idx_del, this.list[idx_del]);
                if (this.list[idx_del].context) {
                    if (this.list.length === 0) {
                        this.list[idx_del].context.clearRect(0, 0, this.current_width, this.current_height);
                        this.list = [];
                        return [];
                    }else{

                        this.list.splice(idx_del, 1);
                        // console.log("new list shapes draw : ", this.list)
                        return this.list;
                    }
                }else{
                    console.warn("Not found context for clear of  ", this.list[idx_del]);

                }
                // this.list
            }else{
                console.warn("Not found index of list shapes ", idx_del);
            }
        }else{
                console.warn("Not found  list shapes || item ", this.list, item);

        }
        return null;
    }

    // text of shape
    set_text(txt){
        this.text = txt;
    }


    get_sizes(){
        return {
            width  : this.current_width,
            height : this.current_height,
        }
    }

    resize(contentD, roiD, streamD){
        this.content     = document.getElementById(contentD);
        this.roi         = document.getElementById(roiD); // + idx / canvas html
        this.streaming   = document.getElementById(streamD);
        
        this.current_width  = this.roi.width  = this.streaming.getBoundingClientRect().width;
        this.current_height = this.roi.height = this.streaming.getBoundingClientRect().height;
    }



    

    
    set_color(){
        // colors and line
        // roi_context.lineWidth = 2; 

        // color ramdom
        let o    = Math.round, r = Math.random, s = 255;
        let ca   = 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ',0.5)';
        let num1 = o(r()*s)
        let num2 = o(r()*s)
        let num3 = o(r()*s)
        

        this.context.strokeStyle =  'rgba('+num1+','+num2+','+num3+',0.5)';//'#ffffff';
        this.context.fillStyle   = 'rgba('+num1+','+num2+','+num3+',0.3)';//'#00ff00';
        this.context.lineWidth   = 3; // line width
    } // set_color

    render_tags(color = 'green'){
        let temp = {};
        let ext  = '';
        if (api && api.isdocker) {
            ext = api.ext;
        }
        if (tags && tags.length > 0) {
            tags.forEach((tag) => {
                if (["alert", "warning", "normal", "success"].includes(tag.key)) {
                    let image_tag = new Image();
                    image_tag.src = ext + tag.img + tag.key + '.png';//'img/tags/person/green2.png';
                    temp[tag.key] =  image_tag;

                }else
                if (tag.img) {
                    let image_tag = new Image();
                    image_tag.src = ext + tag.img + color + '.png';//'img/tags/person/green2.png';
                    // console.log("DRAWER : ", ext + tag.img + color + '.png')
                    temp[tag.key] =  image_tag;
                }
            })

        }
        // console.log("tags : ",temp)
        return temp;
    } // render tags

    // use for draw the default polygon or initial
    draw_shape(opt, idx, info_list, coords, x, y, w, h){
        let vm = this;
        if (this.shape == 'polygon') {
            // console.log("draw_shape", x, y, w, h, opt);
            let polygon = [];
            
            if (opt == 'complet') {
                polygon = [
                        [vm.init_pos_polygon, vm.init_pos_polygon],
                        [vm.current_width - vm.init_pos_polygon, vm.init_pos_polygon],
                        [vm.current_width - vm.init_pos_polygon, vm.current_height - vm.init_pos_polygon],
                        [vm.init_pos_polygon , vm.current_height - vm.init_pos_polygon]
                    ]
            }
            // draw saved coords or points
            if (opt == 'coords') {
                // console.log('coords : ', coords);
                if (coords && coords.length > 0) {
                    coords.forEach((point)=>{
                        if (point[0] && point[1] && !point.includes('NaN')) {                            
                            polygon.push([point[0] * vm.current_width , (point[1]) * vm.current_height])
                        }
                    })
                    // console.log(" Relative to Coords ", idx, polygon, vm.current_width, vm.current_height)
                    if (polygon.length === 0) {
                        polygon = [
                            [x , y ],
                            [w + (x), y],
                            [w + (x), h + (y)],
                            [x , h + (y)]
                        ]
                    }
                }

                // this.polygon = polygon;
            }
            if (opt == 'other') {
                let p = this.padding;
                polygon = [
                    [x , y ],
                    [w + (x), y],
                    [w + (x), h + (y)],
                    [x , h + (y)]
                ]
            }
            if (info_list) {
               this.check_list();
            }
            if (this.list && this.list.length && this.list[idx] && this.list[idx].context) {                
                let contx = this.list[idx].context;
                let Roi   = this.list[idx].roi;

                // console.log( "ended draw ",Roi, idx, this.list[idx], this.list, info_list)     
                
                let Dpoly               = new DrawerPoligon(contx, Roi, 5,this.list[idx].name);
                
                Dpoly.drawPolygon(contx, polygon, Roi, idx);
                this.list[idx].polygon = Dpoly.getCoords();
                this.list[idx].points  = Dpoly.getRelativeCoords();
                this.list[idx].drawer  = Dpoly;
            }

        }
    }

    open_bus(idx){
        if (idx >= 0 && this.list && this.list.length && this.list[idx]) {
            let lis = 'event_stream' + this.list[idx].deviceId;
            this.list[idx].drawer.set_eventBus(this.bus);
            this.list[idx].drawer.start_bus(lis, this.draw_setting, this.tags_images, this.list[idx].deviceId);
        }
    }

    

    drawRect(context, x, y, w, h, idx, text = 'title', color ){         
        // console.log("DRAW : ", context, x, y, w, h)
        context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        context.beginPath();
        /*if (!vm.change_roi) {
        }else{
            context.strokeStyle = 'red';

        }*/
        context.strokeStyle = 'white';              

        if (color == 'blue') {                  
            context.fillStyle   = 'rgba(30, 139, 195, 0.5)'; //'rgba(218, 148, 156, 0.5)';
        }else{
            context.fillStyle   = 'rgba(240, 52, 52, 0.5)'
        }
        context.lineWidth   = 3;
        context.rect(parseInt(x), parseInt(y), parseInt(w), parseInt(h));
        // if (vm.draws[0]) {
        //  context.rect(vm.draws[0].x, vm.draws[0].y, vm.draws[0].w, vm.draws[0].h);
        // }
        context.fill();
        context.stroke();

        context.font      = "16px Georgia";
        context.fillStyle = "rgba(0,0,0,1)";
                 
        context.fillText(text,   x + 20, y + 20);
        this.list[idx].draw.context = context;
        
        
    } // drawRect
   

    // get position x y mouse
    getMousePos(canvas, evt) {
        let rect = canvas.getBoundingClientRect();
        // console.log(rect, 'rect')
        return {
            x: parseInt((evt.clientX - rect.left) / (rect.right - rect.left) * canvas.width),
            y: parseInt((evt.clientY - rect.top) / (rect.bottom - rect.top) * canvas.height)                
        };
    } // getMousePos

    setRelativeCoords(stream, roi, idx){
        if (this.shape == 'polygon') {
            // this.info.coords = {};
            let pointss = [];
            
            for(let iter in stream){                
                pointss.push([(stream[iter][0] / roi.width).toFixed(4), 
                            (stream[iter][1] / roi.height).toFixed(4)]);
            }
            this.points                      = pointss;
            if (this.list && this.list.length > 0 && this.list[idx]) {     
                this.list[idx].points    = pointss;
                this.list[idx].polygon   = stream;
                // console.log("coords", this.list[idx]);
            }
            

        }
    }

    get_coords(list){
        if (this.shape == 'polygon') {
            if (!list) {
                return this.points;
            }else{
                return this.list;

            }
        }
    }

    destroy_content(){
        this.roi.removeEventListener('mousedown');
        this.roi.removeEventListener('mousemove'); 
        this.roi.removeEventListener('mouseup'); 
        // this.roi.removeEventListener('click'); 

    }


    start_draw(contxt){
        let vm = this;
        contxt.addEventListener('mousedown', function(event){
            // console.log('mousedown', vm.idx_point, vm.list)
            const mousePos  = vm.getMousePos(vm.roi, event);
            // console.log(mousePos)

            if (vm.shape == 'rectangle') {
                
                // roi_context = vm.draw_points[vm.idx_point].context;
                vm.color = vm.list_draw[vm.idx_point] && 
                        vm.list_draw[vm.idx_point].color ? 
                        vm.list_draw[vm.idx_point].color : vm.color;

                vm.text  = vm.list_draw[vm.idx_point] && 
                        vm.list_draw[vm.idx_point].title ? 
                        vm.list_draw[vm.idx_point].title : vm.text; 

                vm.stream  = vm.list_draw[vm.idx_point].rect;
                // roi  = vm.draw_points[vm.idx_point].draw;



                vm.side           = vm.pointerIsInBorder(vm.roi, mousePos.x, mousePos.y, stream); //camera = stream                      
                if(side == "body"){

                    if(roi_context.isPointInPath(mousePos.x, mousePos.y)){              
                        dragging = true;
                    }else{
                        drawing = true;
                    }
                }else{
                    resizing = true;
                }           
                vm.aux_left     = mousePos.x;
                vm.aux_top      = mousePos.y;      
            }
            

            // polygon
            if (vm.shape == 'polygon') {
                // console.log("side *****************+ ",side , mousePos, current_width. current_height, roi)
                let find = false;
                let dx, dy, x, y, d; 
                for (let index in vm.polygon) {
                    x  = vm.polygon[index][0];
                    y  = vm.polygon[index][1];
                    dx = Math.abs(mousePos.x -x/*event.clientX - roi.offsetLeft - x*/);
                    dy = Math.abs(mousePos.y -y/*event.clientY - roi.offsetTop - y*/);
                    d  = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    if (d < vm.nodeRadius) {
                    // console.log(d , "NODE RADIUS")
                        find = true;                        
                        vm.nodeIndex                           = index;  
                        
                                              
                        break;
                    }
                }   
                // console.log(d , "NODE RADIUS", find)
                /*.left
                .right
                .middle*/
                if (!find) {
                    
                    vm.list.some( (poly, idx_poly) =>{
                        // let dx, dy, x, y, d; 
                        
                        let polygons = poly.polygon && poly.polygon.length > 0 ? 
                                        poly.polygon : 0; 

                        if (polygons && polygons.length > 0) {
                            
                            for (let index in polygons) {
                                x  = polygons[index][0];
                                y  = polygons[index][1];
                                dx = Math.abs(mousePos.x -x);/*event.clientX - roi.offsetLeft - x*/
                                dy = Math.abs(mousePos.y -y);/*event.clientY - roi.offsetTop - y*/ 
                                d  = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                                // console.log(d , " < ", vm.nodeRadius, poly.name);

                                if (d < vm.nodeRadius) {
                                    // console.log(d , "NODE RADIUS 2")
                                    vm.idx_point                    = idx_poly;
                                    // console.log('mousedown',index)
                                    vm.nodeIndex = index;                                
                                    vm.polygon   = polygons;
                                    vm.roi       = poly.roi;
                                    vm.context   = poly.context;
                                    return true;
                                    break;
                                }
                            }   
                        }
                    })
                }
            } // polygon
        }, false);


        contxt.addEventListener('mousemove', function(event){
            let top, left;
            let mousePos = vm.getMousePos(vm.roi, event);                      
            if (vm.shape == 'rectangle') {
                if(vm.dragging){               
                    draged      = true;
                    left        = parseInt(vm.stream.roi_left) + (mousePos.x - aux_left);
                    top         = parseInt(vm.stream.roi_top)  + (mousePos.y - aux_top);               

                    if(left < 0){
                        left = 0;
                    }
                    if(parseInt(vm.stream.roi_width) + left  > vm.roi.width){
                        left = vm.roi.width - parseInt(vm.stream.roi_width);
                    }           
                    if(top < 0){
                        top = 0;
                    }
                    if(parseInt(vm.stream.roi_height) + top  > vm.roi.height){
                        top  = vm.roi.height - parseInt(vm.stream.roi_height);
                    }
                    vm.drawRect(roi_context, left, top, parseInt(vm.stream.roi_width), parseInt(vm.stream.roi_height), vm.idx_point, text, color);
                }

                if(vm.drawing){                
                    drawed      = true;
                    left        = Math.min(vm.aux_left, mousePos.x);
                    top         = Math.min(vm.aux_top, mousePos.y);
                    aux_width   = Math.abs(mousePos.x - vm.aux_left);
                    aux_height  = Math.abs(mousePos.y - vm.aux_top);   
                    vm.drawRect(roi_context, left, top, aux_width, aux_height, vm.idx_point, text, color);
                }

                if(vm.resizing){               
                    vm.resized = true;

                    if(vm.side == "top"){
                        vm.stream.roi_height   = vm.stream.roi_height - (mousePos.y - vm.stream.roi_top);
                        vm.stream.roi_top      = mousePos.y;
                    }

                    if(vm.side == "bottom"){
                        vm.stream.roi_height = vm.stream.roi_height - ((vm.stream.roi_height + vm.stream.roi_top) - mousePos.y);                        
                    }

                    if(vm.side == "left"){
                        vm.stream.roi_width = vm.stream.roi_width - (mousePos.x - vm.stream.roi_left);
                        vm.stream.roi_left  = mousePos.x;
                    }

                    if(vm.side == "right"){
                        vm.stream.roi_width = vm.stream.roi_width - ((vm.stream.roi_width + vm.stream.roi_left) - mousePos.x);
                    }

                    vm.drawRect(vm.context, vm.stream.roi_left, vm.stream.roi_top, vm.stream.roi_width, vm.stream.roi_height, vm.idx_point, text, color);
                    vm.setRelativeCoords(vm.stream, vm.roi, vm.idx_point);
                }
                if(!vm.drawing && !vm.dragging && !vm.resizing){
                    vm.pointerIsInBorder(vm.roi, mousePos.x, mousePos.y, vm.stream);
                }
            }
            if (vm.shape == 'polygon') {
                if (vm.nodeIndex != null) {
                    // roi_context = context_point;
                    vm.context.clearRect(0, 0, vm.current_width, vm.current_height);                    
                    vm.polygon[vm.nodeIndex][0] = mousePos.x; // event.clientX;
                    vm.polygon[vm.nodeIndex][1] = mousePos.y; //event.clientY;

                    vm.reDrawCamera(vm.context,vm.idx_point)
                    vm.list[vm.idx_point].drawer.drawPolygon(
                        vm.context, 
                        vm.polygon ,  
                        vm.roi, 
                        vm.idx_point
                    );
                }
            }
        }, false);

        contxt.addEventListener('mouseup', function(event){
            
            let mousePos = vm.getMousePos(vm.roi, event);

            vm.resizing = vm.drawing = vm.dragging = false;
            if (vm.shape == 'rectangle') {
                if(vm.drawed){             
                    vm.stream.roi_top    = parseInt(Math.min(vm.aux_top, mousePos.y));
                    vm.stream.roi_left   = parseInt(Math.min(vm.aux_left, mousePos.x));
                    vm.stream.roi_width  = parseInt(Math.abs(mousePos.x - vm.aux_left));
                    vm.stream.roi_height = parseInt(Math.abs(mousePos.y - vm.aux_top));       
                    vm.drawed            = false;
                    vm.setRelativeCoords(vm.stream, vm.roi, vm.idx_point);
                }
                if(vm.draged){
                    vm.stream.roi_left   = parseInt(vm.stream.roi_left) + (mousePos.x - vm.aux_left);
                    vm.stream.roi_top    = parseInt(vm.stream.roi_top)  + (mousePos.y - vm.aux_top);

                    if(parseInt(vm.stream.roi_left) < 0){
                        vm.stream.roi_left = 0;
                    }
                    if(parseInt(vm.stream.roi_width) + parseInt(vm.stream.roi_left)  > vm.roi.width){
                        vm.stream.roi_left = vm.roi.width - parseInt(vm.stream.roi_width);
                    }           
                    if(parseInt(vm.stream.roi_top) < 0){
                        vm.stream.roi_top = 0;
                    }
                    if(parseInt(vm.stream.roi_height) + parseInt(vm.stream.roi_top)  > vm.roi.height){
                        vm.stream.roi_top  = vm.roi.height - parseInt(vm.stream.roi_height);
                    }
                    vm.draged            = false;
                    vm.setRelativeCoords(vm.stream, vm.roi, vm.idx_point);
                }
                if(vm.resized){                
                    vm.resized           = false;              
                    vm.setRelativeCoords(vm.stream, vm.roi, vm.idx_point);
                }           
            } // rectangle
            if (vm.shape == 'polygon') {
                
                vm.nodeIndex = null;
                vm.list[vm.idx_point].polygon = vm.list[vm.idx_point].drawer.getCoords();
                vm.list[vm.idx_point].points  = vm.list[vm.idx_point].drawer.getRelativeCoords();                
                vm.list[vm.idx_point].drawer.check_segment();
                if (!vm.nodeIndex) {
                // const mousePos  = vm.getMousePos(vm.roi, event);
                // console.log("DRAW CLIC ", vm.list)                 
                    vm.list.some( (poly, idx_poly) =>{
                                                
                        if (poly.polygon && poly.polygon.length > 0) {
                            if(vm.pointInPolygon(mousePos.x, mousePos.y, poly.polygon)){
                                vm.reDrawPolygon({
                                    context : poly.context, 
                                    polygon: poly.polygon, 
                                    roi : poly.roi, 
                                    idx : idx_poly,
                                })
                                vm.drawCam(mousePos.x, mousePos.y, poly.context);
                                // console.log("CHECK POINT ", poly)
                                poly.camPoints = vm.convertToRelativeCoords([[mousePos.x, mousePos.y]], poly.roi)
                                return true
                            }
                        }
                    })// some

            } // if end

            }
        }, false);


        /*contxt.onclick = function(evt){   
            if (evt.button==2){
              console.log('presiono clic derecho');
            }else{
              console.log('presiono clic izquierdo');
            }
        }
    
        contxt.addEventListener('contextmenu', function(evt){   
           evt.preventDefault(); // remueve esta linea si quieres que aparezca el menu por defecto.
           console.log("preciono clic derecho menu");
        },false);*/
    }
    pointInPolygon(x, y, vertices) {
        let dentro = false;            
        for (let i = 0, j = vertices.length - 1; i < vertices.length; j = i++) {
            const xi = vertices[i][0];
            const yi = vertices[i][1];
            const xj = vertices[j][0];
            const yj = vertices[j][1];
            const intersecta = ((yi > y) !== (yj > y)) &&
                (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);              
            if (intersecta) dentro = !dentro;
        }

        return dentro;
    }
    drawCam(x,y,context){
        if (context) {
            // console.log("width height ", this.current_width, this.current_height)
            context.drawImage(this.camImage, x-10, y-10, 30, 30)
        }
    }
    reDrawCamera(context,idx){
        if (context && idx>=0) {        
            if (this.list && this.list.length > 0 && this.list[idx].camPoints && this.list[idx].roi) {
                let coords = this.convertRelativeToCoords(this.list[idx].camPoints, this.list[idx].roi);
                if (coords && coords.length > 0 && coords[0]) {                
                    this.drawCam(coords[0][0],coords[0][1],context);
                }
            }
        }
    }
    convertToRelativeCoords(coords, roi){ // for Camera
        let pointss = [];
        if (coords && roi) {
            for(let iter in coords){                                
                pointss.push([(coords[iter][0] / roi.width).toFixed(4), 
                            (coords[iter][1] / roi.height).toFixed(4)]);
            }
            return pointss
        }
        return null

    }
    convertRelativeToCoords(coords){ // for Camera 
        if (coords && coords.length > 0) {
            let points = [];            
            coords.forEach((point)=>{
                if (point[0] && point[1] && !point.includes('NaN')) {                            
                    points.push([point[0] * this.current_width , (point[1]) * this.current_height])
                }
            });
            if (points.length > 0) {
                return points;
            }
        }
        return null;
    }

    setCamPoint(idx, points){
        if (idx>=0 && points && this.list && this.list.length > 0 && this.list[idx]) {
            this.list[idx].camPoints = points;
            if (this.list[idx].drawer) {
                this.list[idx].drawer.setCamPoints(points); 
            }
        }
    }

    reDrawPolygon({context, polygon, roi, idx}){
        let vm = this;
        context.clearRect(0, 0, vm.current_width, vm.current_height);                            
        vm.list[idx].drawer.drawPolygon(
            context, 
            polygon,  
            roi, 
            idx
        );
    }
    

    close_connection(device){
        if (this.bus) {
            let vm = this;
            if (device) {
                let idx = vm.list.findIndex( x => (x && x.deviceId == device));
                if (idx >= 0) {
                    this.list[idx].drawer.close_bus();
                }
            }else{
                vm.list.forEach((dev)=>{
                    dev.drawer.close_bus();
                });
            }
        }
    }

            
}

export default Drawer;
